import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=6390a5d0&scoped=true&"
import script from "./Provider.vue?vue&type=script&lang=js&"
export * from "./Provider.vue?vue&type=script&lang=js&"
import style1 from "./Provider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390a5d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
